export default __webpack_public_path__ + "static/media/health2.4f1d735f.jpg";